const types = {
    SEND_BULK_NOTIFICATIONS_START: "SEND_BULK_NOTIFICATIONS_START",
    SEND_BULK_NOTIFICATIONS_SUCCESS: "SEND_BULK_NOTIFICATIONS_SUCCESS",
    SEND_BULK_NOTIFICATIONS_ERROR: "SEND_BULK_NOTIFICATIONS_ERROR",
    SEND_BULK_NOTIFICATIONS_STATE_RESET: "SEND_BULK_NOTIFICATIONS_STATE_RESET",
}

export default types;